document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.product-hotspots-wrapper');
  if (!wrapper) return;

  const hotspots = JSON.parse(wrapper.dataset.hotspots || '[]');
const mediaItems = document.querySelectorAll('.product__media-item[data-media-id]');

  mediaItems.forEach(mediaItem => {
    const mediaIdRaw = mediaItem.dataset.mediaId;
    const mediaIdNumber = mediaIdRaw?.split('-').pop();
    const imageGid = `gid://shopify/MediaImage/${mediaIdNumber}`;

    const imageEntry = hotspots.find(h => h.imageId === imageGid);
    const imageHotspots = imageEntry?.products || [];
    if (!imageHotspots.length) return;

    // Maak een container onder de afbeelding

    const hotspotBar = document.createElement('div');
    hotspotBar.className = 'hotspot-bar';
    mediaItem.appendChild(hotspotBar);

    imageHotspots.forEach(hotspot => {
      const card = document.createElement('div');
      card.className = 'hotspot-card';
      card.innerHTML = `
  <div class="hotspot-card__inner">
    <a class="hotspot-popup__link" href="/products/${hotspot.productHandle}">Shop</a>
  </div>
`;

      fetch(`/products/${hotspot.productHandle}.js`)
        .then(r => r.json())
        .then(data => {
          if (data.featured_image) {
            const rawUrl = data.featured_image;
            const smallUrl = rawUrl.replace(/(\.[^.]+)$/, '_100x100$1');
            const img = document.createElement('img');
            img.className = 'hotspot-popup__image';
            img.src = smallUrl;
            img.alt = hotspot.productTitle;
            card.insertBefore(img, card.querySelector('.hotspot-card__inner'));
          }
        });

      hotspotBar.appendChild(card);
    });
  });
});
